import { ChangeDetectionStrategy, Component, Input, QueryList, ViewChildren } from '@angular/core';
import { DashboardDevice } from '@vi-iot/client';

import { PillComponent } from '../../../../shared/components/pill/pill.component';
import { DashboardOperatingModePipe } from '../../pipes/dashboard-operating-mode/dashboard-operating-mode.pipe';
import { PillType } from '../../../../shared/components/pill/pill.model';
import { CommonStandaloneModule } from '../../../../shared/common-standalone.module';
import { DashboardAnomalyPillPipe } from '../../pipes/dashboard-anomaly-pill/dashboard-anomaly-pill.pipe';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { matTooltipSetter } from 'src/app/shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-installation-tile-device-badges',
  standalone: true,
  templateUrl: './installation-tile-device-badges.component.html',
  styleUrls: ['./installation-tile-device-badges.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonStandaloneModule,
    PillComponent,
    DashboardAnomalyPillPipe,
    DashboardOperatingModePipe,
    MatTooltipModule,
  ],
})
export class InstallationTileDeviceBadgesComponent {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  readonly pillType = PillType;
  @Input({ required: true }) device: DashboardDevice;
}
